import { defineStore } from 'pinia'
import { ReplaceUploadGroup } from '@ve-pro/api/asset-group/type'
import { ReplaceMode, LanguagesMode, LanguagesTab } from '@ve-pro/enums/replace'
import { useTrackStore } from '..'
import _ from 'lodash'
import { AssetSource } from '@ve-pro/enums/asset'

export const useReplaceStore = defineStore('replace', {
  state: () => {
    return {
      // 素材上传、多语言裂变
      mode: ReplaceMode.Upload as ReplaceMode,
      // 详情页、多语言裂变
      languagesMode: LanguagesMode.Languages as LanguagesMode,
      languagesTab: LanguagesTab.Layout,
      // 详情页-进入视频id
      detailVideoId: 0 as number,
      // 详情页-进入的语言
      detailLanguage: '' as string,
      // 详情页-更新配音按钮
      detailUpdateBtnDisabled: false as boolean,
      // 上传文件列表
      uploadFilesList: [] as ReplaceUploadGroup[],
      searchKey: '',
      searchLanguage: 'all',
      searchResultCount: 0,
      // TODO： 该用 EventBus 来通信
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
      replaceCallback: (search: string, lang: string, replace: string) => {},
    }
  },
  getters: {
    languageSegments(state) {
      if (process.env.NODE_ENV !== 'development') {
        return {}
      }

      const trackStore = useTrackStore()

      const langSegments = trackStore.segments.filter((segment) => {
        return segment.source_segment_id
      })

      const group = _.groupBy(langSegments, (segment) => {
        return segment.lang
      })
      const _group = {} as any
      _.forEach(group, (child, key) => {
        _group[key] = _.groupBy(child, (segment) => {
          return segment.source_segment_id
        })
      })

      return _group
    },
  },
  actions: {
    removeUploadFilesList(data: { key: number; file_id: number }) {
      this.uploadFilesList = this.uploadFilesList.filter(
        (item: ReplaceUploadGroup) => {
          return !(item.id === data.file_id && item.group_id === data.key)
        },
      )
    },
    addUploadFilesList(
      files: any[],
      props: Pick<
        ReplaceUploadGroup,
        'group_id' | 'groupChild' | 'assetType' | 'replaceChildId'
      >,
    ) {
      // @ts-expect-error 复制前就报错的
      const newFiles: ReplaceUploadGroup[] = files.map((f) => {
        return {
          ...props,
          asset_id: '',
          source_id: '',
          id: f.id,
          name: f.name,
          progress: 0,
          type: 'upload',
          status: '',
          source: AssetSource.Asset,
        }
      })

      this.uploadFilesList = this.uploadFilesList.concat(newFiles)
    },
    setSearchKey(key: string) {
      this.searchKey = key
    },
    setSearchLanguage(language: string) {
      this.searchLanguage = language
    },
    globalReplaceText(text: string) {
      // @ts-ignore
      this.replaceCallback &&
        this.replaceCallback(this.searchKey, this.searchLanguage, text)
    },
  },
})
